import { render, staticRenderFns } from "./collection-form.vue?vue&type=template&id=5e5b4cbc"
import script from "./collection-form.vue?vue&type=script&lang=js"
export * from "./collection-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports